import SubscriptionTierService from 'src/modules/subscriptionTier/subscriptionTierService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'SUBSCRIPTIONTIER_VIEW';

const subscriptionTierViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subscriptionTierViewActions.FIND_STARTED,
      });

      const record = await SubscriptionTierService.find(id);

      dispatch({
        type: subscriptionTierViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subscriptionTierViewActions.FIND_ERROR,
      });

      getHistory().push('/subscription-tier');
    }
  },
};

export default subscriptionTierViewActions;
